const meetingIdParam = 'meetingId';
const jobPositionIdParam = 'jobPositionId';
const candidateIdParam = 'candidateId';
const valueIdParam = 'valueId';
const inviteTokenParam = 'inviteToken';
const teamUuid = 'teamId';
const userUuid = 'userId';
const cultureVitalParam = 'cultureVitalSlug';
const cultureKpiUuidParam = 'cultureKpiUuid';
const assessmentPopulationSummaryParam = 'assessmentId';
const instillCoachActionStepUuidParam = 'actionStepUuid';
const demoAccountCompanySlugParam = 'companySlug';
const actionStepUuidParam = 'actionStepUuid';
const metricTrendUuidParam = 'metricTrendUuid';
const behaviorInsightUuidParam = 'behaviorInsightUuid';
const kudoUuidParam = 'kudoUuid';
const openKudosParam = 'openKudos';

export const routeParams = {
  kudoUuidParam,
  openKudosParam,
  meetingIdParam,
  jobPositionIdParam,
  candidateIdParam,
  valueIdParam,
  teamUuid,
  userUuid,
  inviteTokenParam,
  cultureVitalParam,
  assessmentPopulationSummaryParam,
  instillCoachActionStepUuidParam,
  demoAccountCompanySlugParam,
  actionStepUuidParam,
  cultureKpiUuidParam,
  metricTrendUuidParam,
  behaviorInsightUuidParam,
};
